export default __webpack_public_path__ + "static/media/collaborative.e721ec0a.png";